import cx from 'classnames'
import { FormApi } from 'final-form'
import setFieldTouched from 'final-form-set-field-touched'
import React from 'react'
import { Form } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'

import { Alert } from '@cinch-labs/design-system'
import { Primary } from '@cinch/oxd-components/button/src'
import Panel from '@cinch/oxd-components/panel/src'
import Steps from '../steps'

import getAllDependants from '../../stages/manual-lookup/get-all-dependants'
import { Journey } from '../../types'
import Question from '../question/question.component'
import buildInitialValues from './build-initial-values'
import { Pages } from '../../types'

import * as styles from './journey.module.css'

export interface DetailsProps {
  journey?: Journey
  onSubmit: (formData: any) => Promise<any>
  i18n: Cinch.WebAppTranslations['sellVehicle']['questions']
  onFieldChange?: (field: string, form: FormApi) => any
  path: Pages
}

/**
 * This component builds the main journey panels, each page gets its own panel
 */
const Details: React.FC<DetailsProps> = ({ journey, onSubmit, i18n, onFieldChange, path }) => {
  if (!journey) {
    return null
  }
  const initialValues = buildInitialValues(journey)

  const { journeyPages } = journey
  const { submit: submitText, carDetails, yourDetails } = i18n

  return (
    <Form
      onSubmit={(formData: any) => onSubmit(formData)}
      initialValues={initialValues}
      mutators={{ setFieldTouched } as any}
      render={({ handleSubmit, submitting, submitError, form, invalid }) => (
        <form onSubmit={handleSubmit} className={styles.form}>
          <Steps page={path} />
          <div className={styles.pages}>
            <Panel>
              {journeyPages.map((page, index) => {
                const fieldsetLegend = index === 0 ? carDetails : yourDetails

                return (
                  <fieldset className={cx(styles.fieldset, styles.details)} key={page.pageNumber}>
                    <legend>{fieldsetLegend}</legend>
                    {
                      /*
                        filter: temp fix to remove optional telephone number input from details form
                        TODO: replace with question.isHidden property decorator pending deployment/completion
                        of WBAC proxy service: https://trello.com/c/wCqgqlI8/75-set-non-required-telephonenumber-field-ishidden-flag-from-proxy-service
                      */
                      page.pageQuestions
                        .filter((question) => question.isRequired)
                        .map((question) => (
                          <React.Fragment key={question.questionParameterId}>
                            <Question
                              question={question}
                              validateFields={onFieldChange && getAllDependants(page.pageQuestions, question)}
                            />
                            {onFieldChange && (
                              <OnChange name={question.questionParameterName}>
                                {() => onFieldChange(question.questionParameterName, form)}
                              </OnChange>
                            )}
                          </React.Fragment>
                        ))
                    }
                  </fieldset>
                )
              })}

              <div className={styles.buttonContainer}>
                <Primary
                  disabled={invalid && !submitError}
                  oxdClassName={styles.button}
                  type="submit"
                  isLoading={submitting}
                  oxford={true}
                >
                  {submitText || 'Continue'}
                </Primary>
              </div>
            </Panel>
          </div>
          {submitError && (
            <div className={styles.alert}>
              <Alert oxford={true}>{submitError}</Alert>
            </div>
          )}
        </form>
      )}
    />
  )
}

export default Details
